const template = document.createElement('template');

template.innerHTML = `
  <style>
.container {
    padding: 8px;
}
  button {
  background-color: #E21C21;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
</style>

<div class="container">
    <button>Exit Now</button>
  </div>
`;

class LeaveButton extends HTMLElement {
    constructor() {
        super();

        this._shadowRoot = this.attachShadow({ mode: 'open' });
        this._shadowRoot.appendChild(template.content.cloneNode(true));

        this.$button = this._shadowRoot.querySelector('button');

        this.$button.addEventListener('click', () => {
            window.open(this.url_open, "_newtab"); // open new tab and switch to it.
            window.location.replace(this.url_replace); // load alternative.            
        });
    }

    connectedCallback() {
        if (this.hasAttribute('as-atom')) {
            this.$container.style.padding = '0px';
        }

        if (!this.hasAttribute('url_open')) {
            this.setAttribute('url_open', 'https://www.google.com');
        }

        if (!this.hasAttribute('url_replace')) {
            this.setAttribute('url_replace', 'https://www.bing.com');
        }        
    }

    get label() {
        return this.getAttribute('label');
    }

    set label(value) {
        this.setAttribute('label', value);
    }

    get url_open() {
        return this.getAttribute('url_open');
    }

    set url_open(value) {
        this.setAttribute('url_open', value);
    }

    get url_replace() {
        return this.getAttribute('url_replace');
    }

    set url_replace(value) {
        this.setAttribute('url_replace', value);
    }

    static get observedAttributes() {
        return ['label', 'url_open', 'url_replace'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
        this.render();
    }

    render() {
        this.$button.innerHTML = this.label;
    }
}

window.customElements.define('leave-button', LeaveButton);